module.exports = __webpack_public_path__ + "img/drug-dog(old).4551d26c.png";